import React from 'react';

import { Badge, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

import {useProps} from "@/Shared/FuncComp";
import Link from "@/Shared/Link";

const CartIcon = (props) => {
	const {cart=0} = useProps();
	if (!cart) return null;
	return <Button variant="primaryLight" as={Link} link="cotizar" className="d-flex align-items-center text-light" style={{fontSize: "1.25em"}}>
		<FontAwesomeIcon size="lg" icon={faShoppingCart} />
		<Badge variant="light" className="ml-2" style={{top: 0}}>{cart}</Badge>
	</Button>
}

export default CartIcon;
